<template>
  <div class="mnd-step">
    <div class="mnd-step__content mnd-step__content_slim">
      <h4 class="mnd-step__minititle">Адрес имущества</h4>
      <LinkField @toField="$emit('toSlide', 2)" name="Населённый пункт" :value="form.address.city" />
      <LinkField v-if="!form.address.nostreet" @toField="$emit('toSlide', 2)" name="Улица" :value="form.address.street" />
      <LinkField @toField="$emit('toSlide', 2)" name="Дом" :value="form.address.house" />
      <LinkField @toField="$emit('toSlide', 2)" name="Квартира" :value="form.address.flat" />
      <h4 class="mnd-step__minititle">Страхователь</h4>
      <LinkField @toField="$emit('toSlide', 2)" name="Фамилия" :value="form.personal.name" />
      <LinkField @toField="$emit('toSlide', 2)" name="Имя" :value="form.personal.surname" />
      <LinkField @toField="$emit('toSlide', 2)" name="Отчество" :value="form.personal.patronymic" />
      <LinkField @toField="$emit('toSlide', 2)" name="Дата рождения" :value="form.personal.birthdate" />
      <LinkField @toField="$emit('toSlide', 2)" name="Пол" :value="form.personal.sex" />
      <LinkField @toField="$emit('toSlide', 2)" name="Место рождения" :value="form.personal.birthplace" />
      <h4 class="mnd-step__minititle">Паспорт гражданина РФ</h4>
      <LinkField @toField="$emit('toSlide', 2)" name="Серия и номер паспорта" :value="form.passport.number" />
      <LinkField @toField="$emit('toSlide', 2)" name="Дата выдачи" :value="form.passport.releasedate" />
      <h4 class="mnd-step__minititle">Контактная информация</h4>      
      <LinkField @toField="$emit('toSlide', 2)" name="Телефон" :value="form.contacts.tel" />
      <LinkField @toField="$emit('toSlide', 2)" name="E-mail" :value="form.contacts.email" />
      <div class="mnd-step__minititle mnd-step__example"><a :href="sendResponse.policyUrl" target="_blank">Посмотреть образец полиса</a></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import LinkField from '../LinkField.vue';
export default {
  props: {
    filledStatus: { type: Object },
    index: { type: Number, default: 3 }
  },
  mounted() {
    //eslint-disable-next-line
    this.filledStatus[this.index] = true;
  },
  computed: {
    ...mapState(['form','sendResponse'])
  },
  components: { LinkField }
}
</script>

<style lang="sass">
.mnd-step__content_slim
  width: 100%
  max-width: globalvars.$slimwidth
  margin: 0 auto
.mnd-step__example  
  padding: 20px 0
  a
    cursor: pointer
    text-decoration: underline
    text-underline-offset: 4px
    text-decoration-thickness: 1px

</style>